const Actions = {
    /*
    Account Authentication
    */
    USER_SET: 'USER_SET',
    USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    USER_LOGIN_WARNING: 'USER_LOGIN_WARNING',
    USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',
    USER_SESSION_EX: 'USER_SESSION_EX',
    USER_SESSION_NUL: 'USER_SESSION_NUL',
    USER_LOGOUT: 'USER_LOGOUT',
    /*
    Account Register
    */
    USER_ACCOUNT_VALIDATE: 'USER_ACCOUNT_VALIDATE',
    USER_APPLICATION_VALIDATE: 'USER_APPLICATION_VALIDATE',
    USER_REGISTER_REQUEST: 'USER_REGISTER_REQUEST',
    USER_REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
    USER_REGISTER_FAIL: 'USER_REGISTER_FAIL',
    /*
    Password Change
     */
    USER_PASSWORD_CHG_REQUEST:'USER_PASSWORD_CHG_REQUEST',
    USER_PASSWORD_CHG_SUCCESS:'USER_PASSWORD_CHG_SUCCESS',
    USER_PASSWORD_CHG_FAIL:'USER_PASSWORD_CHG_FAIL',
    /*
    user attr change
     */
    USER_CHG_ATTR_REQUEST:'USER_CHG_ATTR_REQUEST',
    USER_CHG_ATTR_SUCCESS:'USER_CHG_ATTR_SUCCESS',
    USER_CHG_ATTR_FAIL:'USER_CHG_ATTR_FAIL',
    USER_NEW_ATTR:'USER_NEW_ATTR',
    /*
    user profile image
     */
    USER_PRO_IMG_REQUEST:'USER_PRO_IMG_REQUEST',
    USER_PRO_IMG_SUCCESS:'USER_PRO_IMG_SUCCESS',
    USER_PRO_IMG_FAIL:'USER_PRO_IMG_FAIL',

    /*
    Merchant
    */
    MERCHANT_DETAIL_REQUEST: 'MERCHANT_DETAIL_REQUEST',
    MERCHANT_DETAIL_SUCCESS: 'MERCHANT_DETAIL_SUCCESS',
    MERCHANT_DETAIL_FAIL: 'MERCHANT_DETAIL_FAIL',
    MERCHANT_DETAIL_RESET: 'MERCHANT_DETAIL_RESET',
    MERCHANT_PUB_KEY_REQUEST: 'MERCHANT_PUB_KEY_REQUEST',
    MERCHANT_PUB_KEY_SUCCESS: 'MERCHANT_PUB_KEY_SUCCESS',
    MERCHANT_PUB_KEY_NOTFOUND: 'MERCHANT_PUB_KEY_NOTFOUND',
    MERCHANT_PUB_KEY_FAIL: 'MERCHANT_PUB_KEY_FAIL',
    MERCHANT_PRI_KEY_REQUEST: 'MERCHANT_PRI_KEY_REQUEST',
    MERCHANT_PRI_KEY_SUCCESS: 'MERCHANT_PRI_KEY_SUCCESS',
    MERCHANT_PRI_KEY_NOTFOUND: 'MERCHANT_PRI_KEY_NOTFOUND',
    MERCHANT_PRI_KEY_FAIL: 'MERCHANT_PRI_KEY_FAIL',
    MERCHANT_KEY_GEN_REQUEST: 'MERCHANT_KEY_GEN_REQUEST',
    MERCHANT_KEY_GEN_SUCCESS: 'MERCHANT_KEY_GEN_SUCCESS',
    MERCHANT_KEY_GEN_FAIL: 'MERCHANT_KEY_GEN_FAIL',
    MERCHANT_SET_ENDPOINT_REQUEST: 'MERCHANT_SET_ENDPOINT_REQUEST',
    MERCHANT_SET_ENDPOINT_SUCCESS: 'MERCHANT_SET_ENDPOINT_SUCCESS',
    MERCHANT_SET_ENDPOINT_FAIL: 'MERCHANT_SET_ENDPOINT_FAIL',

    /*
    API Key request
    */
    MERCHANT_APIKEY_REQUEST: 'MERCHANT_APIKEY_REQUEST',
    MERCHANT_APIKEY_SUCCESS: 'MERCHANT_APIKEY_SUCCESS',
    MERCHANT_APIKEY_FAIL: 'MERCHANT_APIKEY_FAIL',
    MERCHANT_APIKEY_EXIST: 'MERCHANT_APIKEY_EXIST',

    /*
    Transaction
    */
    TRANSACTION_REQUEST: 'TRANSACTION_REQUEST',
    TRANSACTION_SUCCESS: 'TRANSACTION_SUCCESS',
    TRANSACTION_FAIL: 'TRANSACTION_FAIL',

    /*
    Insurance
     */
    INSURANCE_MORE_REQUEST: 'INSURANCE_MORE_REQUEST',
    INSURANCE_MORE_SUCCESS: 'INSURANCE_MORE_SUCCESS',
    INSURANCE_MORE_FAIL: 'INSURANCE_MORE_FAIL',
    INSURANCE_EXPORT_REQUEST: 'INSURANCE_EXPORT_REQUEST',
    INSURANCE_EXPORT_SUCCESS: 'INSURANCE_EXPORT_SUCCESS',
    INSURANCE_EXPORT_FAIL: 'INSURANCE_EXPORT_FAIL',

    /*
    UserManagement
     */
    USER_MGT_REQUEST: 'USER_MGT_REQUEST',
    USER_MGT_SUCCESS: 'USER_MGT_SUCCESS',
    USER_MGT_FAIL: 'USER_MGT_FAIL',
    USER_STATE_CHG_REQUEST: 'USER_STATE_CHG_REQUEST',
    USER_STATE_CHG_SUCCESS: 'USER_STATE_CHG_SUCCESS',
    USER_STATE_CHG_FAIL: 'USER_STATE_CHG_FAIL',
    USER_ATTR_CHG_REQUEST: 'USER_ATTR_CHG_REQUEST',
    USER_ATTR_CHG_SUCCESS: 'USER_ATTR_CHG_SUCCESS',
    USER_ATTR_CHG_FAIL: 'USER_ATTR_CHG_FAIL',

    /*
    Dashboard
    */
    DASHBOARD_REQUEST: 'DASHBOARD_REQUEST',
    DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
    DASHBOARD_FAIL: 'DASHBOARD_SUCCESS'

};

export default Actions;

